export default function ArrowTopRightIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Arrow Top Right Icon</title>
      <g clipPath="url(#clip0_1784_92)">
        <path
          d="M9.55228 10.7712L15.6026 10.9826L14.8375 10.2175L14.9986 16.2176L16.3778 14.8384L16.3275 9.99606L15.8241 9.4927L10.9315 9.39203L9.55228 10.7712ZM9.26033 15.4927L10.2872 16.5196L15.6328 11.1739L14.606 10.1471L9.26033 15.4927Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1784_92">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(0 1 -1 0 24.5 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
